import http from "../../backend/http.js";

async function getStage(id) {
  try {
    const response = await http.get(`crm/sales-funnel-stages/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      date: response.data.date,
      type: response.data.salesFunnelType,
    };
  } catch (err) {
    throw err;
  }
}

async function updateStage(id, data) {
  try {
    const response = await http.put(`crm/sales-funnel-stages/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createStage(data) {
  try {
    const response = await http.post("crm/sales-funnel-stages", data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getStages(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `crm/sales-funnel-stages?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectStage(
    page = 1,
    rowsPerPage = 9,
    search = "",
    salesFunnelTypeId = null,
) {
  try {
    const response = await http.get(
      "crm/sales-funnel-stages/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
          salesFunnelTypeId,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}


export { getStage, updateStage, selectStage, getStages, createStage };
